import config from '@/config'
const cleverreachResourceUrl = `${config.resourceHost}cleverreach`

export default {
  endpoints: {
    settings: `${cleverreachResourceUrl}/settings`,
    token: `${cleverreachResourceUrl}/token`,
    sync: `${cleverreachResourceUrl}/sync`,
  },
  externalUrls: {
    cleverreachLoginBaseUrl: 'https://rest.cleverreach.com/oauth/authorize.php',
    cleverreachRegisterUrl: 'https://www.cleverreach.com/de/partnerprogramm/#register',
  },
}
